'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';

let settings = {
	handlerSelector: '.js-ajax-handler',
};


class AjaxHandler {
	constructor(options) {
		this.opt = $.extend(true, {}, settings, options);
		this.init();
	}
	init() {
		console.log('[ AjaxHandler/init ]');

		$(document.body).on('click', this.opt.handlerSelector, function(e) {
			let self = this;
			e.preventDefault();

			let params = $(self).data();

			if ($(self).attr('href') && $(self).attr('href') != '#') {
				params['_back'] = $(self).attr('href');
			}

			let text = params.confirm || 'Вы уверены?';
			text = text.replace(/\\n/g, "\n");
			delete params.confirm;

			if (confirm(text)) {
				self.loading = true;

				Ajax.get('handler', params).then((data) => {
					delete self.loading;
					if (data.error) {
						if (data.error_text) {
							alert(data.error_text);
						}
					} else if (data.redirect_url) {
						document.location.href = data.redirect_url;
						document.location.reload(true);
					} else {
						if (data.back) {
							document.location.href = document.location.protocol + '//' + document.location.hostname + data.back;
							document.location.reload(true);
						} else {
							if (!data.noreload) {
								document.location.reload(true);
							}
							if (data.export) {
							  saveAs(document.location.protocol + '//' + document.location.hostname + data.file_path, data.file_name);
							}
						}
					}
				}).catch(function(error) {
					throw new Error(error);
				});
			}
		});
	}
}


export {
	AjaxHandler
};
